import React, { useContext } from 'react';
import {Grid, Button, Icon} from 'semantic-ui-react';
import _ from 'lodash';
import {Contexts} from 'componentLibrary';

const {RequestDetailsContext} = Contexts;
const ItemWrapper = ({
  activityKey,
  activityName,
  editable,
  addItem,
  allowAdd,
  children,
  narative,
  isNarrative,
  childItemLabel,
}) => {
  let labelHeader = 'Cost Items';
  let buttonHeader = 'Add an item';
  
  if (childItemLabel !== 'item') {
    labelHeader = _.upperFirst(`${childItemLabel}`);
    buttonHeader = `Add a ${childItemLabel}`;
  }
  
  const rdContext = useContext(RequestDetailsContext);
  const hideButtons = _.get(rdContext, 'customizations.hideButtons', false);

  return (
    <React.Fragment>
      {isNarrative && (
        <Grid.Row style={{'marginBottom': '50px'}}>
          <Grid.Column width={16}>{narative()}</Grid.Column>
        </Grid.Row>
      )}
         
      <div className="accordion-subhead-block w-clearfix">
        <h5 className="apph5 accordion-subhead pull-down">{labelHeader}</h5>
        {editable && allowAdd && !hideButtons && (
          <Button
            as="a"
            href="#"
            primary
            small
            basic
            className="app-button_secondary white float-right w-button"
            onClick={(e) => {
              e.preventDefault();
              addItem();
            }}
            id={`add-item-${activityKey}`}
            title={`Open pop-up form to add item to ${activityName}`}
          >
            <span class="fa-link-lg-btn">
              <Icon name="add" />
            </span>{' '}
            {buttonHeader}
          </Button>
        )}
      </div>
      {children}
    </React.Fragment>
  );
};
export default ItemWrapper;
